import { useEffect, useState, useRef, ReactNode } from "react";
import { usePost } from "../Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import Table from "./Table.tsx";
import { usePaginationState } from "./Pagination.tsx";

export const _QueryTable = ({
  query,
  queryParams,
  asyncOptions,
  getList = (data) => data?.list,
  getCount = (data) => data?.count,
  filterBy = {},
  parentState,
  sortByState,
  paginationState,
  trClassName,
  nomPage,
  ...props
}: _QueryTable) => {
  const [pagination] = paginationState;
  // FIXME : trouver une meilleure solution pour gérer le retour en arrière
  const [sortBy] = sortByState;
  const [tableState, setTableState] = useState([]);

  const { isRejected, isLoading, data, run } = parentState
    ? parentState
    : // eslint-disable-next-line react-hooks/rules-of-hooks
      usePost(
        queryParams ? query + "?" + url`${queryParams}` : query,
        asyncOptions,
      );
  const firstMount = useRef(true);

  const fetchData = () => {
    // on ne veut pas relancer un chargement immédiatement si on passe un state parent
    if (firstMount.current) {
      firstMount.current = false;
      if (parentState) {
        return;
      }
    }
    if (
      JSON.stringify(tableState) !==
      JSON.stringify([filterBy, sortBy, pagination.limit, pagination.offset])
    ) {
      setTableState([filterBy, sortBy, pagination.limit, pagination.offset]);
      if (pagination.limit >= 0 && pagination.offset >= 0) {
        run({
          limit: pagination.limit,
          offset: pagination.offset,
          filterBy: filterBy,
          sortBy: sortBy,
        });
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterBy, sortBy, pagination.limit, pagination.offset]);

  if (isRejected) {
    return <div>Une erreur est servenue.</div>;
  }

  return (
    <Table
      manual
      showPagination
      paginationState={paginationState}
      sortByState={sortByState}
      isLoading={isLoading}
      data={getList(data)}
      count={getCount(data)}
      trClassName={trClassName}
      nomPage={nomPage}
      {...props}
    />
  );
};

export type _QueryTable = {
  query: string;
  queryParams: object;
  filterBy: object;
  parentState: object;
  asyncOptions: object;
  getList: (values: any) => object;
  getCount: (values: any) => number;
  sortByState: any[];
  paginationState: any[];
  trClassName: string;
  nomPage: ReactNode;
};

const QueryTable = ({
  query,
  queryParams,
  asyncOptions,
  getList = (data) => data?.list,
  getCount = (data) => data?.count,
  parentState,
  sortByState,
  ...props
}: QueryTableType) => {
  return (
    <_QueryTable
      query={query}
      queryParams={queryParams}
      getList={getList}
      getCount={getCount}
      parentState={parentState}
      asyncOptions={asyncOptions}
      sortByState={sortByState}
      paginationState={usePaginationState()}
      {...props}
    />
  );
};

type QueryTableType = {
  query: string;
  queryParams: object;
  parentState: object;
  asyncOptions: object;
  getList: (values: any) => object;
  getCount: (values: any) => number;
  sortByState: any[];
  sticky: boolean;
};

export default QueryTable;
